export class ContentPreview {
    id: string;
    name: string;
    type: 'lesson' | 'quiz';
    image?: string;

    constructor(data: { id: string; name: string; type: 'lesson' | 'quiz'; image?: string }) {
        this.id = data.id ?? '';
        this.name = data.name ?? '';
        this.type = data.type;
        this.image = data.image ?? '';
    }
}
